<template>
  <div class="card">
    <div class="bg-blue-light p-2">
      <TitleButton :showBtn="false" title="Payment Requisition - Disbursement" />
    </div>

    <div class="px-3 mt-2">
      <ul class="nav nav-tabs custom-nav-tab">
        <li v-for="tab in tabs" :key="tab.id" class="nav-item">
          <a
            :class="['nav-link', { active: activeTab === tab.id }]"
            @click="setActiveTab(tab.id)"
          >
            {{ tab.title }}
          </a>
        </li>
      </ul>
    </div>

    <div class="p-2">
      <MakePaymentTab v-if="activeTab === 'make_payment'" />
      <ClearanceTab v-if="activeTab === 'clearance'" />
      <BeftnStatementTab v-if="activeTab === 'beftn_statement'" />
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import TitleButton from '@/components/atom/TitleButton'
import MakePaymentTab from './disbursement/MakePaymentTab.vue'
import ClearanceTab from './disbursement/ClearanceTab.vue'
import BeftnStatementTab from './disbursement/BeftnStatementTab.vue'

const tabs = [
  { id: 'make_payment', title: 'Make Payment' },
  { id: 'clearance', title: 'Clearance' },
  { id: 'beftn_statement', title: 'BEFTN Statement' },
]

const route = useRoute()
const router = useRouter()

const validTabs = tabs.map((tab) => tab.id)
const activeTab = ref(validTabs.includes(route.query.tab) ? route.query.tab : 'make_payment')

const setActiveTab = async (id) => {
  if (activeTab.value === id) return
  const routeQuery = Object.assign({}, route.query, { tab: id })
  delete routeQuery.page
  await router.push({ path: route.path, query: routeQuery })
  activeTab.value = id
}
</script>
